export default __webpack_public_path__ + "static/media/CM_detector.dcd86758.svg";